import React from 'react'
import PropTypes from 'prop-types'
import { compose, withHandlers, withProps } from 'recompose'
import DataBlock from '../texts/data-block'

const DataBlockEditable = compose(
  withHandlers({
    onEdit: props => e => {
      e.preventDefault()
      props.onEditContact(props.id)
    },
    onDelete: props => e => {
      e.preventDefault()
      props.onDeleteContact(props.id)
    }
  }),
  withProps(props => ({
    hasActions: true
  }))
)(DataBlock)

const ContactItem = props => {
  const { contact, isEditable, onEditContact, onDeleteContact } = props
  const items = []
  if (contact.phone) items.push({ icon: 'phone', text: contact.phone })
  if (contact.fax) items.push({ icon: 'fax', text: contact.fax })
  if (contact.email)
    items.push({
      icon: 'email2',
      text: contact.email,
      hasLink: true,
      linkUrl: `mailto:${contact.email}`
    })
  const DataBlockConfigured = isEditable ? DataBlockEditable : DataBlock
  return (
    <DataBlockConfigured
      className='has-divider'
      label={contact.name}
      items={items}
      id={contact.id}
      onEditContact={onEditContact}
      onDeleteContact={onDeleteContact}
    />
  )
}

ContactItem.propTypes = {
  contact: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    phone: PropTypes.string,
    fax: PropTypes.string,
    email: PropTypes.string
  }),
  isEditable: PropTypes.bool,
  onEditContact: PropTypes.func,
  onDeleteContact: PropTypes.func
}

export default ContactItem



// WEBPACK FOOTER //
// ./src/ui/contacts/contact-item.js